// extracted by mini-css-extract-plugin
var _1 = "inner-mTgjz";
export { _1 as "inner" }
